"use client";

import { useMedia } from "react-use";
import { Dialog } from "@hubble/web";

import Link from "components/parts/NextLink";
import { Button } from "app/_components/components/Button";
import DownloadAppModal from "app/_components/components/DownloadAppModal";

import Android from "./icons/Android";
import Apple from "./icons/Apple";

import { mediaQuery } from "utils";

const ICON = {
  ios: <Apple className="h-5 w-5" />,
  android: <Android className="h-5 w-5" />
};

const DownloadButton = ({
  text,
  type
}: {
  text: string;
  type: "ios" | "android";
}) => {
  const isTablet = useMedia(mediaQuery.tabletSmDown, false);

  if (isTablet)
    return (
      <Button asChild size="md">
        <Link
          className="tablet:w-fit w-[220px] gap-2.5 !bg-white hover:!bg-white/[0.63] active:!bg-white/[0.63]"
          id="homepage-v2-start-trading-today-btn"
          href="https://geminiexchange.app.link/fL2oDHN39pb"
        >
          {ICON[type]}
          {text}
        </Link>
      </Button>
    );

  return (
    <Dialog>
      <Dialog.Trigger asChild>
        <Button
          className="!bg-white hover:!bg-white/[0.63] active:!bg-white/[0.63]"
          size="md"
        >
          {ICON[type]}
          {text}
        </Button>
      </Dialog.Trigger>
      <DownloadAppModal />
    </Dialog>
  );
};

export default DownloadButton;
